export function useSessionStorage(key: string) {
  function getSessionValue() {
    return sessionStorage.getItem(key);
  }

  function setSessionValue(v: string): void {
    sessionStorage.setItem(key, v);
  }

  return { getSessionValue, setSessionValue };
}
